// Shared with the server. Request deadlines use UTC+3, independently of the device timezone.
const OFFSET = 3 * 60 * 60 * 1000;
const DAY = 24 * 60 * 60 * 1000;
const DEADLINE_CODES = ['REQUEST_DEADLINE_REQUIRED', 'REQUEST_DEADLINE_INVALID', 'REQUEST_DEADLINE_PAST', 'REQUEST_URGENCY_REQUIRED'];

function deadlineParts(value) {
    const date = normalizeDeadline(value);
    if (!date) return {date: '', time: '11:00'};
    const iso = new Date(date.getTime() + OFFSET).toISOString();
    return {date: iso.slice(0, 10), time: iso.slice(11, 16)};
}

function normalizeDeadline(value) {
    if (!value) return null;
    if (typeof value === 'string') {
        const calendar = /^(\d{4})-(\d{2})-(\d{2})(?:T|$)/.exec(value);
        if (calendar) {
            const day = new Date(`${calendar[1]}-${calendar[2]}-${calendar[3]}T00:00:00Z`);
            if (!Number.isFinite(day.getTime()) || day.toISOString().slice(0, 10) !== calendar[0].slice(0, 10)) return null;
        }
    }
    const raw = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
        ? `${value}T11:00:00+03:00` : value;
    const result = new Date(raw);
    if (!Number.isFinite(result.getTime())) return null;
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) &&
        new Date(result.getTime() + OFFSET).toISOString().slice(0, 10) !== value) return null;
    return result;
}

function composeDeadline(date, time = '11:00') {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date || '') || !/^\d{2}:\d{2}$/.test(time || '')) return null;
    const value = normalizeDeadline(`${date}T${time}:00+03:00`);
    if (!value) return null;
    const parts = deadlineParts(value);
    return parts.date === date && parts.time === time ? value.toISOString() : null;
}

function deadlinePolicy(type = {}, fields = {}, now = Date.now()) {
    const clock = new Date(now);
    const today = new Date(clock.getTime() + OFFSET).toISOString().slice(0, 10);
    const days = Math.max(0, Number(type.submission_deadline_days) || 0);
    const minimumDate = new Date(Date.parse(`${today}T00:00:00Z`) + (type.is_emergency ? 0 : days) * DAY).toISOString().slice(0, 10);
    const deadline = normalizeDeadline(fields.deadline);
    const deadlineUrgent = Boolean(deadline && !type.is_emergency && days > 0 && deadlineParts(deadline).date < minimumDate);
    const urgent = fields.priority === 'urgent' || deadlineUrgent;
    const reasonRequired = urgent && type.requires_justification_if_late !== false;
    let code = null;
    let message = '';
    if (!fields.deadline) {
        code = 'REQUEST_DEADLINE_REQUIRED'; message = 'Укажите дату и время выполнения заявки';
    } else if (!deadline) {
        code = 'REQUEST_DEADLINE_INVALID'; message = 'Укажите корректные дату и время выполнения заявки';
    } else if (deadline.getTime() <= clock.getTime()) {
        code = 'REQUEST_DEADLINE_PAST'; message = 'Срок уже прошёл. Выберите будущие дату и время — обоснование срочности не заменяет новый срок.';
    } else if (reasonRequired && !String(fields.urgency_comment || '').trim()) {
        code = 'REQUEST_URGENCY_REQUIRED'; message = 'Перенесите срок с учётом регламента или укажите причину срочности';
    }
    return {code, message, urgent, deadlineUrgent, reasonRequired, today, minimumDate,
        serverNow: clock.toISOString(), requiredDays: days, timeZone: 'UTC+3'};
}

function assertDeadline(type, fields, options = {}) {
    const policy = deadlinePolicy(type, fields, options.now);
    if (policy.code && !(options.allowMissing && policy.code === 'REQUEST_DEADLINE_REQUIRED') &&
        !(options.allowPastDeadline && policy.code === 'REQUEST_DEADLINE_PAST') &&
        !(options.skipReason && policy.code === 'REQUEST_URGENCY_REQUIRED')) {
        const error = new Error(policy.message);
        error.statusCode = 400;
        error.code = policy.code;
        error.details = {...policy, field: policy.code === 'REQUEST_URGENCY_REQUIRED' ? 'urgency_comment' : 'deadline'};
        throw error;
    }
    return policy;
}

function formatDeadline(value) {
    const parts = deadlineParts(value);
    return parts.date ? `${parts.date.split('-').reverse().join('.')} ${parts.time} (UTC+3)` : 'Не установлен';
}

module.exports = {deadlineParts, normalizeDeadline, composeDeadline, deadlinePolicy, assertDeadline, formatDeadline, DEADLINE_CODES};
